import * as React from "react";
import type { SVGProps } from "react";
const SvgEdit03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.8 19.552h6m-15.6 0 4.366-.88a1.2 1.2 0 0 0 .612-.328l9.773-9.78a1.2 1.2 0 0 0 0-1.697L16.88 4.8a1.2 1.2 0 0 0-1.697.001l-9.775 9.78a1.2 1.2 0 0 0-.328.61z"
    />
  </svg>
);
export default SvgEdit03;
